/**
 * Appends generic UTM referral parameters to a given outbound URL.
 *
 * @param url - The original URL string without query parameters.
 * @returns The URL string with UTM parameters applied.
 */
export function addUtmTrackingToUrl(url: string): string {
    const utmParams = new URLSearchParams({
        utm_source: "rwa.xyz",
        utm_medium: "referral",
    });

    return `${url}?${utmParams.toString()}`;
}
